import React from 'react'

import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import * as ROUTES from 'admin/routes'
import { CompanyEditForm } from './CompanyEditForm'
import { ShortcutsModalButton } from 'admin/lib/ShortcutsModalButton'
import { Guid } from 'admin/lib/guid'

const DEFAULT_COMPANY = Object.freeze({
  companyId: Guid.Empty,
  name: '',
  companyNumber: '',
  address: '',
  companyCertificates: [],
  resourceURI: ''
})

export function CompanyRegister() {
  return (
    <Layout
      header={
        <>
          <Breadcrumb
            items={[
              {
                title: (
                  <BreadcrumbArrayItem href={ROUTES.REFERENCE_DATA.INDEX}>
                    Reference Data
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: (
                  <BreadcrumbArrayItem href={ROUTES.COMPANIES.LIST}>
                    Companies
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: 'New'
              }
            ]}
          />

          <ShortcutsModalButton />
        </>
      }
    >
      <CompanyEditForm company={DEFAULT_COMPANY} isNew />
    </Layout>
  )
}
